/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Cookies from "universal-cookie";
import { USER_API } from "../../common/common";
import { getComparator, Logout, stableSort } from "../../common/Funcation";
import Loader from "../../components/Loader";
// import { bookExposerGetPopup } from '../../redux/reducer';
import {
  getApi,
  notifyError,
  notifyMessage,
  postApi,
  postApiLink,
  sendEvent,
} from "../../service";
import Login from "../Login";
import BetBox from "./BetBox";
import {
  DetailsTableInterface,
  FancyInterface,
  PinInterface,
  PreMainInterface,
  PreSubInterface,
} from "./interface";
import FancyInfoModal from "./FancyInfoModal";
import PremiumInfoModal from "./PremiumInfoModal";
import Slider from "react-slick";
import MarketDepthPopup from "./MarketDepthPopup";
import ReactPlayer from "react-player";
import OddsDammyData from "../../components/multiMarket/OddsDammyData";
import Footer from "../../components/Footer";
import BottomFooter from "../../components/BottomFooter";
import { Height } from "@mui/icons-material";
import moment from "moment";

const fancySetting = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  variableWidth: true,
  arrows: false,
};

const premiumSetting = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  variableWidth: true,
  arrows: false,
};

const sportsWidgetSetting = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 2.3,
  slidesToScroll: 2.3,
  // variableWidth: true,
  arrows: false,
};

const cookies = new Cookies();

const DEFAULT_SCORE_CARD_HEIGHT = 190;
const SCORE_CARD_EXPAND_THRESHOLD = 40;
function sportStreamId(type: string) {
  const value = String(type || "").toLowerCase();
  if (value.includes("esoccer") || value.includes("e-soccer")) return 137;
  if (value.includes("basket")) return 7522;
  if (value.includes("soccer") || value.includes("football")) return 1;
  if (value.includes("tennis")) return 2;
  return 4;
}

function splitMatchTeams(name: string) {
  const parts = String(name || "").split(/\s+v(?:s\.?)?\s+/i);
  return {
    left: (parts[0] || "").trim(),
    right: (parts.slice(1).join(" v ") || "").trim(),
  };
}

function fancyLineClosed(status: any) {
  const value = String(status || "").trim().toUpperCase();
  if (!value || value === "ACTIVE" || value === "OPEN") return false;
  return true;
}

function fancyClosedMessage(status: any) {
  const value = String(status || "").trim().toUpperCase();
  if (value === "BALL RUNNING") return "Ball Running";
  if (value === "SUSPEND" || value === "SUSPENDED") return "Suspend";
  return "Bet Rejected! Odds Changes.";
}

// Match Odds. Ball running stays its own label; both it and suspend close the price.
function oddsHoldText(status: any) {
  const value = String(status ?? "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, " ");
  if (value === "BALL RUNNING" || value === "BALLRUNNING" || value === "BALL_RUNNING") {
    return "Ball Running";
  }
  if (value === "SUSPEND" || value === "SUSPENDED") return "Suspended";
  return "";
}

// Suspend switches from admin sport settings close a whole market while the
// feed may still show it open; mark its rows the way the feed marks a suspend.
const ADMIN_SUSPEND_SECTIONS: Array<["page" | "pre", string, string]> = [
  ["page", "t1", "odds"],
  ["page", "t2", "bookmaker"],
  ["page", "t3", "fancy"],
  ["pre", "t4", "premium"],
];

function withAdminSuspend(payload: any) {
  const suspend = payload?.matchInfo?.suspend;
  if (!suspend || typeof suspend !== "object") return payload;
  let next = payload;
  for (const [source, table, market] of ADMIN_SUSPEND_SECTIONS) {
    const rows = payload?.[source]?.data?.[table];
    if (suspend[market] !== true || !Array.isArray(rows)) continue;
    if (next === payload) next = { ...payload };
    next[source] = {
      ...next[source],
      data: {
        ...next[source].data,
        [table]: rows.map((row: any) =>
          row && typeof row === "object" && !/^DEACTIV/i.test(String(row.status ?? ""))
            ? { ...row, status: "SUSPEND" }
            : row
        ),
      },
    };
  }
  return next;
}

function fancyRowStatus(item: any) {
  return item && typeof item === "object" && "status" in item ? item.status : "";
}

function hasLiveScore(score1: any, score2: any) {
  return score1 != null && score2 != null && score1 !== "" && score2 !== "";
}

function findListedMatch(lists: any[], eventId: any) {
  const id = String(eventId || "");
  if (!id) return null;
  for (const list of lists) {
    if (!Array.isArray(list)) continue;
    const found = list.find((match) => String(match?.gameId) === id);
    if (found) return found;
  }
  try {
    const cached = JSON.parse(localStorage.getItem("sportsData") || "null");
    if (cached && String(cached.gameId) === id) return cached;
  } catch {
    return null;
  }
  return null;
}

const hasData = (d: any) => d && Object.keys(d).length > 0;

// Builds a temporary "detail" object from the list page snapshot so the page can
// paint instantly. The socket payload replaces it as soon as it arrives.
function readPreviewFromCache(eventId?: string, marketId?: string) {
  try {
    const c = JSON.parse(localStorage.getItem("sportsData") || "null");
    if (
      !c ||
      String(c.gameId) !== String(eventId) ||
      String(c.marketId) !== String(marketId) ||
      !Array.isArray(c.t1) ||
      !c.t1.length
    ) {
      return null;
    }
    return {
      __preview: true,
      matchInfo: {
        _id: c._id,
        gameId: c.gameId,
        marketId: c.marketId,
        name: c.eventName || c.name,
        type: c.type,
        // real limits if the list page had them; otherwise don't grey anything out
        oddsLimit: c.oddsLimit ?? { min: 0, max: Infinity },
        bet_odds_limit: c.bet_odds_limit,
        suspend: c.suspend,
      },
      page: { data: { t1: c.t1 } },
    };
  } catch {
    return null;
  }
}

const MultiMarket = () => {
  const matchIntervalRef = useRef<any>(null);
  const HeaderData = useSelector((e: any) => e.Header);
  const isMountedRef = useRef(true);
  const [isLoadingMain, setIsLoadingMain] = useState(false);
  const isAuthenticated = useSelector((e: any) => e.isAuthenticated);
  const isUserLoggedIn = Boolean(
    isAuthenticated && cookies.get("skyTokenFront")
  );
  const SPORT_DETAILS = useSelector((e: any) => e.sportDetails);
  const BET_HISTORY = useSelector((e: any) => e.betHistory);
  const cricketList = useSelector((e: any) => e.cricket);
  const soccerList = useSelector((e: any) => e.soccer);
  const tennisList = useSelector((e: any) => e.tennis);
  const [placeBetLoader, setPlaceBetLoader] = useState(false);
  // const [mainLoader, setMainLoader] = useState(true);
  const [tab, setTab] = useState("cricket");
  const [fancyPremium, setFancyPremium] = useState(true); // fancybet is default
  const dispatch = useDispatch();
  const [openLive, setopenLive] = useState<any>("live");
  const [detailsPage, setDetailsPage] = useState<any>({
    eventId: "",
    marketId: "",
  });
  const navigate = useNavigate();
  let { eventId, marketId } = useParams<any>();          // moved up
  const isMultiMarketListPage = !eventId || !marketId;   // moved up
  const previewDetail = useMemo(
    () => (isMultiMarketListPage ? null : readPreviewFromCache(eventId, marketId)),
    [eventId, marketId, isMultiMarketListPage]
  );
  const [detailSport, setDetailSport] = useState<any>(() =>
    hasData(SPORT_DETAILS) ? withAdminSuspend(SPORT_DETAILS) : previewDetail || {}
  );
  const isPreview = !!detailSport?.__preview;
  const [clickedBet, setClickedBet] = useState<DetailsTableInterface | any>();
  const [clickedTableData, setClickedTableData] = useState<string>("");
  const [openedPre, setOpenedPre] = useState<any>([]);
  const [toggledAccordions, setToggledAccordions] = useState<Record<string, boolean>>({});
  const [clickedTable, setClickedTable] = useState<string>("");
  const [videoDetails, setVideoDetails] = useState<any>({});
  const [loginPopup, setLoginPopup] = useState(false);
  const [positonModal, setPositonModal] = useState<boolean>(false);
  const [HistorySuccess, setHistorySuccess] = useState(false);
  const [positonDetails, setPositonDetails] = useState<any>({
    data: [],
    type: "",
  });
  const [isSportLoading, setIsSportLoading] = useState<boolean>(true);
  const [blockStatus, setBlockStatus] = useState<any>({});
  const [t4Main, setT4Main] = useState<any>({});
  const [sportsWidget, setSportsWidget] = useState<any>([]);
  const [liveTvUrl, setLiveTvUrl] = useState("");
  const [liveScoreUrl, setLiveScoreUrl] = useState("");
  const [scoreCardHeight, setScoreCardHeight] = useState(DEFAULT_SCORE_CARD_HEIGHT);
  const [sportsId, setSportsId] = useState(4);
  const [activeFancyTab, setActiveFancyTab] = useState(0);
  const [activePremiumTab, setActivePremiumTab] = useState(0);

  const fancyTabsRef = useRef<(HTMLDivElement | null)[]>([]);
  const [fancyLineStyle, setFancyLineStyle] = useState({ left: 0, width: 38.3 });

  const premiumTabsRef = useRef<(HTMLDivElement | null)[]>([]);
  const [premiumLineStyle, setPremiumLineStyle] = useState({ left: 0, width: 38.3 });

  const [activeTab, setActiveTab] = useState(!detailSport?.page?.data?.t3?.length ? "premiumfancy" : "fancybet")
  const [isInitialLoad, setIsInitialLoad] = useState(true)

  // Live TV scrolling animation
  const [isTvMini, setIsTvMini] = useState(false);
  const [isTvClosed, setIsTvClosed] = useState(false);

  const [tvPosition, setTvPosition] = useState({
    x: typeof window !== "undefined" ? window.innerWidth - window.innerWidth * 0.5 - 9 : 150,
    y: 56,
  });

  const tvContainerRef = useRef<HTMLDivElement | null>(null);
  const tvPosRef = useRef({
    x: typeof window !== "undefined" ? window.innerWidth - window.innerWidth * 0.5 - 9 : 150,
    y: 56,
  });

  const tvDragRef = useRef({
    dragging: false,
    startX: 0,
    startY: 0,
    startTvX: 0,
    startTvY: 0,
    rafId: 0,
  });

  // SN: BetBox stack delay solution
  const [manageStack, setManageStack] = useState();

  // SN: BetBox stack delay solution
  const getStack = async (token: any) => {
    let data = {
      api: USER_API.GET_STACK,
      value: {},
      token: token ? token : undefined,
    };

    await getApi(data)
      .then(function (response) {
        let resData = response.data?.data?.stackInfo;
        if (response.data?.data?.stackInfo?.stack?.length > 0) {
          setManageStack(resData);
        } else {
          resData.stack = [10, 20, 30, 40, 50, 60, 70, 80];
          setManageStack(resData);
        }

        // setOpenSetting(!OpenSetting)
        // setSearchData(response.data.data)
      })
      .catch((err) => {
        console.log(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (cookies.get("skyTokenFront")) {
      getStack(cookies.get("skyTokenFront"));
    }
    return () => { };
  }, []);

  // Clamp mini TV inside viewport on window resize
  useEffect(() => {
    const handleResize = () => {
      const tvWidth = window.innerWidth * 0.5;
      const tvHeight = tvWidth * (9 / 16);
      const maxX = Math.max(8, window.innerWidth - tvWidth - 8);
      const maxY = Math.max(8, window.innerHeight - tvHeight - 8);
      const curX = tvPosRef.current.x;
      const curY = tvPosRef.current.y;
      const clampedX = Math.min(Math.max(8, curX), maxX);
      const clampedY = Math.min(Math.max(8, curY), maxY);
      if (clampedX !== curX || clampedY !== curY) {
        tvPosRef.current = { x: clampedX, y: clampedY };
        setTvPosition({ x: clampedX, y: clampedY });
        if (tvContainerRef.current) {
          tvContainerRef.current.style.left = `${clampedX}px`;
          tvContainerRef.current.style.top = `${clampedY}px`;
        }
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // When returning to large TV, clear any inline left/top styles
  useEffect(() => {
    if (!isTvMini && tvContainerRef.current) {
      tvContainerRef.current.style.left = "";
      tvContainerRef.current.style.top = "";
    }
  }, [isTvMini]);

  // If live tab is not active, ensure mini TV is closed
  useEffect(() => {
    if (openLive !== "live") {
      setIsTvMini(false);
    }
  }, [openLive]);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          // If bet box is open or not live tab, restore full width TV
          if (clickedTableData.length > 0 || openLive !== "live") {
            setIsTvMini((prev) => (prev ? false : prev));
            ticking = false;
            return;
          }

          const scrollY = window.scrollY || window.pageYOffset;

          // Back to top -> restore full TV
          if (scrollY <= 20) {
            setIsTvMini((prev) => (prev ? false : prev));
            setIsTvClosed((prev) => (prev ? false : prev));
            ticking = false;
            return;
          }

          // Scrolled down past 50px -> show mini TV (hysteresis buffer prevents flutter)
          if (!isTvClosed && scrollY > 50) {
            setIsTvMini((prev) => (!prev ? true : prev));
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isTvClosed, clickedTableData, openLive]);

  const handleTvPointerDown = (e: React.PointerEvent<HTMLDivElement>) => {
    if (!isTvMini) return;

    const target = e.target as HTMLElement;

    // Don't start dragging when clicking the close button
    if (target.closest(".mini-tv-close")) {
      return;
    }

    e.preventDefault();

    const drag = tvDragRef.current;
    drag.dragging = true;
    drag.startX = e.clientX;
    drag.startY = e.clientY;
    drag.startTvX = tvPosRef.current.x;
    drag.startTvY = tvPosRef.current.y;

    const el = tvContainerRef.current;
    if (el) {
      el.classList.add("is-dragging");
    }

    try {
      e.currentTarget.setPointerCapture(e.pointerId);
    } catch { }

    const onWindowPointerMove = (moveEv: PointerEvent) => {
      if (!drag.dragging) return;
      moveEv.preventDefault();

      const deltaX = moveEv.clientX - drag.startX;
      const deltaY = moveEv.clientY - drag.startY;

      const tvEl = tvContainerRef.current;
      const tvWidth = tvEl ? tvEl.offsetWidth : window.innerWidth * 0.5;
      const tvHeight = tvEl ? tvEl.offsetHeight : (window.innerWidth * 0.5) * (9 / 16);

      const minX = 8;
      const maxX = Math.max(minX, window.innerWidth - tvWidth - 8);
      const minY = 8;
      const maxY = Math.max(minY, window.innerHeight - tvHeight - 8);

      const x = Math.min(Math.max(minX, drag.startTvX + deltaX), maxX);
      const y = Math.min(Math.max(minY, drag.startTvY + deltaY), maxY);

      tvPosRef.current = { x, y };

      if (drag.rafId) {
        cancelAnimationFrame(drag.rafId);
      }

      drag.rafId = requestAnimationFrame(() => {
        if (tvEl) {
          tvEl.style.left = `${x}px`;
          tvEl.style.top = `${y}px`;
        }
      });
    };

    const onWindowPointerUp = (upEv: PointerEvent) => {
      if (!drag.dragging) return;
      drag.dragging = false;

      if (drag.rafId) {
        cancelAnimationFrame(drag.rafId);
        drag.rafId = 0;
      }

      const tvEl = tvContainerRef.current;
      if (tvEl) {
        tvEl.classList.remove("is-dragging");
      }

      window.removeEventListener("pointermove", onWindowPointerMove);
      window.removeEventListener("pointerup", onWindowPointerUp);
      window.removeEventListener("pointercancel", onWindowPointerUp);

      try {
        e.currentTarget.releasePointerCapture(e.pointerId);
      } catch { }

      setTvPosition({ x: tvPosRef.current.x, y: tvPosRef.current.y });
    };

    window.addEventListener("pointermove", onWindowPointerMove, { passive: false });
    window.addEventListener("pointerup", onWindowPointerUp);
    window.addEventListener("pointercancel", onWindowPointerUp);
  };


  useEffect(() => {
    // Only set initial state when data loads for the first time
    if (isInitialLoad && detailSport && Object.keys(detailSport).length > 0 && !detailSport.__preview) {
      if (!detailSport?.page?.data?.t3?.length && isUserLoggedIn) {
        // Fancybet data not available, activate premiumfancy by default only if logged in
        setActiveTab("premiumfancy")
        setFancyPremium(false)
      }
      else {
        // Fancybet data available or guest user, activate fancybet by default
        setActiveTab("fancybet")
        setFancyPremium(true)
      }
      setIsInitialLoad(false)
    }
  }, [detailSport, isInitialLoad, isUserLoggedIn])

  useEffect(() => {
    if (fancyTabsRef.current[activeFancyTab]) {
      const el = fancyTabsRef.current[activeFancyTab];
      setFancyLineStyle({ left: el?.offsetLeft || 0, width: el?.offsetWidth || 0 });
    }
  }, [activeFancyTab, detailSport]);

  useEffect(() => {
    if (premiumTabsRef.current[activePremiumTab]) {
      const el = premiumTabsRef.current[activePremiumTab];
      setPremiumLineStyle({ left: el?.offsetLeft || 0, width: el?.offsetWidth || 0 });
    }
  }, [activePremiumTab, detailSport]);

  if (
    window.performance &&
    detailsPage.eventId &&
    detailsPage.marketId &&
    window.innerWidth < 993
  ) {
    if (performance.navigation.type == 1) {
      // navigate('/')
    } else {
    }
  }

  const getBlockStatus = async () => {
    let match_id = null;
    let sportsData = localStorage.getItem("sportsData");

    if (sportsData) {
      const sportsDataTemp = JSON.parse(sportsData);
      match_id = sportsDataTemp._id;
    }
    if (!match_id) return false;

    let data = {
      api: USER_API.GET_BLOCK,
      value: {
        matchId: match_id,
      },
    };

    await postApi(data)
      .then(function (response) {
        if (JSON.stringify(response.data.data.blockMatchDetail) === "{}") {
          setBlockStatus({
            blockAll: false,
            blockOdds: false,
            blockBookMaker: false,
            blockFancy: false,
            blockPremium: false,
            //   matchId: id
          });
        } else {
          setBlockStatus(response.data.data.blockMatchDetail);
        }
      })
      .catch((err) => {
        debugger;
        if (err?.response?.data?.statusCode === 401) {
          Logout();
          // navigate('/login')
        }
      });
  };

  const [pageData, setPageData] = useState<any>();
  const [collapsedPins, setCollapsedPins] = useState<Record<string, boolean>>({});
  const [oddsFlash, setOddsFlash] = useState<Record<string, boolean>>({});
  const pinnedPollRef = useRef<any[]>([]);
  const betMatchRef = useRef<any>(null);

  // useEffect(() => {
  //   // debugger;
  //   if (isAuthenticated && cookies.get("skyTokenFront")) {
  //     getPageData("cricket");
  //   }
  //   getSportWidget(eventId);
  //   return () => { };
  // }, []);

  useEffect(() => {
    // /multimarket
    if (!eventId && !marketId) {
      getPageData();
      return;
    }

    // /multimarket/:eventId/:marketId
    if (eventId && marketId) {
      getSportWidget(eventId);
    }
  }, [eventId, marketId]);

  useEffect(() => {
    if (!isMultiMarketListPage) return;
    const gameId = SPORT_DETAILS?.matchInfo?.gameId;
    const marketIdFromOdds = SPORT_DETAILS?.matchInfo?.marketId;
    const t1 = SPORT_DETAILS?.page?.data?.t1;
    if (gameId == null || marketIdFromOdds == null || !Array.isArray(t1) || !t1.length) {
      return;
    }
    const prevItem = (pinnedPollRef.current || []).find(
      (item: any) =>
        String(item?.gameId) === String(gameId) &&
        String(item?.marketId) === String(marketIdFromOdds)
    );
    const flashKeys: string[] = [];
    if (Array.isArray(prevItem?.t1) && prevItem.t1.length) {
      t1.forEach((runner: any, idx: number) => {
        const old =
          prevItem.t1.find((row: any) => row?.sId != null && row.sId === runner?.sId) ||
          prevItem.t1[idx];
        if (!old) return;
        const id = `${prevItem._id || prevItem.gameId}-${runner?.sId ?? idx}`;
        if (Number(old.b1) !== Number(runner?.b1)) flashKeys.push(`${id}:back`);
        if (Number(old.l1) !== Number(runner?.l1)) flashKeys.push(`${id}:lay`);
      });
    }
    setPageData((prev: any) => {
      const pin = prev?.list?.[0]?.pin;
      if (!Array.isArray(pin) || !pin.length) return prev;
      let changed = false;
      const next = pin.map((item: any) => {
        if (
          String(item?.gameId) !== String(gameId) ||
          String(item?.marketId) !== String(marketIdFromOdds)
        ) {
          return item;
        }
        changed = true;
        return {
          ...item,
          t1,
          oddsSuspended: SPORT_DETAILS?.matchInfo?.suspend?.odds === true,
          bet_odds_limit:
            SPORT_DETAILS?.matchInfo?.bet_odds_limit || item?.bet_odds_limit,
        };
      });
      if (!changed) return prev;
      pinnedPollRef.current = next;
      return { list: [{ pin: next }] };
    });
    if (!flashKeys.length) return;
    setOddsFlash((prev) => {
      const next = { ...prev };
      flashKeys.forEach((key) => delete next[key]);
      return next;
    });
    window.setTimeout(() => {
      setOddsFlash((prev) => {
        const next = { ...prev };
        flashKeys.forEach((key) => {
          next[key] = true;
        });
        return next;
      });
    }, 30);
    window.setTimeout(() => {
      setOddsFlash((prev) => {
        const next = { ...prev };
        flashKeys.forEach((key) => delete next[key]);
        return next;
      });
    }, 700);
  }, [SPORT_DETAILS, isMultiMarketListPage]);

  useEffect(() => {
    if (!isMultiMarketListPage || !isAuthenticated || !cookies.get("skyTokenFront")) {
      return;
    }
    const pullOdds = () => {
      if (typeof document !== "undefined" && document.visibilityState === "hidden") {
        return;
      }
      (pinnedPollRef.current || []).forEach((item: any) => {
        if (!item?.gameId || !item?.marketId) return;
        sendEvent("GET_SPORTS_DETAILS", {
          eventId: Number(item.gameId),
          marketId: item.marketId,
          domain: window.location.hostname,
        });
      });
    };
    const timer = setInterval(pullOdds, 1000);
    return () => clearInterval(timer);
  }, [isMultiMarketListPage, isAuthenticated]);

  // useEffect(() => {
  //   if (isMultiMarketListPage) return;
  //   setIsLoadingMain(true);
  //   setDetailSport(withAdminSuspend(SPORT_DETAILS));
  //   if (JSON.stringify(SPORT_DETAILS) !== "{}") {
  //     setIsLoadingMain(false);
  //   }
  //   return () => { };
  // }, [SPORT_DETAILS, isMultiMarketListPage]);

  useEffect(() => {
    if (isMultiMarketListPage) return;
    if (hasData(SPORT_DETAILS)) {
      setDetailSport(withAdminSuspend(SPORT_DETAILS));
      setIsLoadingMain(false);
    } else if (previewDetail) {
      setDetailSport(previewDetail);
      setIsLoadingMain(false);
    } else {
      setDetailSport(withAdminSuspend(SPORT_DETAILS));
      setIsLoadingMain(true);
    }
  }, [SPORT_DETAILS, isMultiMarketListPage, previewDetail]);

  const getPageData = async () => {
    // Skip API call if user is not authenticated
    if (!isAuthenticated || !cookies.get("skyTokenFront")) {
      setPageData({ list: [{ pin: [] }] });
      setIsLoadingMain(false);
      return;
    }

    setIsLoadingMain(true);
    const types = ["cricket", "soccer", "tennis"];
    try {
      const responses = await Promise.all(
        types.map((type) =>
          postApi({
            api: USER_API.MULTI_LIST,
            value: { type },
          }).catch(() => null)
        )
      );
      const pin: any[] = [];
      responses.forEach((response, index) => {
        const rows = response?.data?.data?.list?.[0]?.pin || [];
        rows.forEach((item: any) => {
          pin.push({ ...item, type: item?.type || types[index] });
        });
      });
      setPageData({ list: [{ pin }] });
      pinnedPollRef.current = pin;
    } catch (err: any) {
      if (err?.response?.data?.statusCode === 401) {
        Logout();
      }
    } finally {
      setIsLoadingMain(false);
    }
  };

  const unpinMatch = async (e: React.MouseEvent, item: any) => {
    e.stopPropagation();
    if (!item?._id || !item?.type) return;

    // Optimistically update local state
    setPageData((prev: any) => {
      const pin = (prev?.list?.[0]?.pin || []).filter(
        (row: any) => String(row?._id) !== String(item._id)
      );
      pinnedPollRef.current = pin;
      return { list: [{ pin }] };
    });

    try {
      await postApi({
        api: USER_API.PIN,
        value: {
          sportId: item._id,
          type: item.type,
          flag: false,
        },
      });
    } catch (err: any) {
      // Rollback on error
      getPageData();
      if (err?.response?.data?.statusCode === 401) {
        Logout();
      }
    }
  };
  const getSportWidget = async (id: any) => {
    let data = {
      api: USER_API.GET_SPORTS_WIDGET,
      value: {
        gameId: id,
      },
    };

    await postApi(data)
      .then(function (response) {
        // console.log("::::::::::>>>>", response);
        setSportsWidget(response.data.data.sportDetail);
      })
      .catch((err) => {
        if (err?.response?.data?.statusCode === 401) {
          // Logout()
          // navigate('/login')
        }
      });
  };

  useEffect(() => {
    if (isMultiMarketListPage) {
      return;
    }

    const timer = setTimeout(() => {
      sendEvent("GET_SPORTS", { type: "cricket" });
    }, 3000);

    window.onbeforeunload = () => {
      dispatch({ type: "GET_SCORE_ID", payload: [] });
    };

    getVideoUrl();

    return () => {
      clearTimeout(timer);

      dispatch({
        type: "GET_SPORTS_DETAILS",
        payload: {},
      });

      setDetailSport({});
    };
  }, [isMultiMarketListPage]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  // const getMatchData = () => {
  //   setIsLoadingMain(true)
  //   let data: any = {};
  //   if (eventId && marketId) {
  //     setDetailsPage({ eventId: parseInt(eventId), marketId: marketId });

  //     data.eventId = parseInt(eventId);
  //     data.marketId = marketId;
  //     data.domain = window.location.hostname;
  //     let num = 1;
  //     if (interval) clearInterval(interval);
  //     interval = setInterval(() => {
  //       if (typeof document !== "undefined" && document.visibilityState === "hidden") {
  //         return;
  //       }
  //       if ((HistorySuccess || BET_HISTORY) && isMountedRef.current) {
  //         if (num === 1 || (isAuthenticated && cookies.get("skyTokenFront"))) {
  //           sendEvent("GET_SPORTS_DETAILS", data);
  //           num += 1;
  //         }
  //         if (isAuthenticated && cookies.get("skyTokenFront")) {
  //           getBlockStatus();
  //         }
  //       }
  //     }, 1000);
  //   }
  // };

  const getMatchData = () => {
    // Do nothing on /multimarket
    if (!eventId || !marketId) {
      return;
    }

    if (!previewDetail) setIsLoadingMain(true);

    const data: any = {
      eventId: parseInt(eventId),
      marketId: marketId,
      domain: window.location.hostname,
    };

    setDetailsPage({
      eventId: parseInt(eventId),
      marketId: marketId,
    });

    if (matchIntervalRef.current) {
      clearInterval(matchIntervalRef.current);
    }

    const isUserLoggedIn = Boolean(
      isAuthenticated && cookies.get("skyTokenFront")
    );

    // Send immediate request if guest or if bet history is ready
    if (!isUserLoggedIn || HistorySuccess || BET_HISTORY) {
      sendEvent("GET_SPORTS_DETAILS", data);
      if (isUserLoggedIn) {
        getBlockStatus();
      }
    }

    matchIntervalRef.current = setInterval(() => {
      if (
        typeof document !== "undefined" &&
        document.visibilityState === "hidden"
      ) {
        return;
      }

      if (isMountedRef.current) {
        const loggedIn = Boolean(
          isAuthenticated && cookies.get("skyTokenFront")
        );
        if (!loggedIn || HistorySuccess || BET_HISTORY) {
          sendEvent("GET_SPORTS_DETAILS", data);
        }

        if (loggedIn) {
          getBlockStatus();
        }
      }
    }, 1000);
  };

  useEffect(() => {
    const isUserLoggedIn = Boolean(
      isAuthenticated && cookies.get("skyTokenFront")
    );
    if (
      isUserLoggedIn &&
      eventId &&
      marketId &&
      (HistorySuccess || BET_HISTORY)
    ) {
      sendEvent("GET_SPORTS_DETAILS", {
        eventId: parseInt(eventId),
        marketId: marketId,
        domain: window.location.hostname,
      });
      getBlockStatus();
    }
  }, [HistorySuccess]);

  useEffect(() => {
    if (isMultiMarketListPage) return;

    isMountedRef.current = true;
    if (!previewDetail) setIsLoadingMain(true);
    getMatchData();

    return () => {
      isMountedRef.current = false;
      if (matchIntervalRef.current) {
        clearInterval(matchIntervalRef.current);
      }
      setToggledAccordions({});
      dispatch({ type: "GET_SPORTS_DETAILS", payload: {} });
      setDetailSport({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId, marketId, isAuthenticated]);

  // const pinClick = (e: any, SUBITEM: PinInterface) => {
  //     console.log(SUBITEM);
  //     setDetailsPage({ eventId: SUBITEM.gameId, marketId: SUBITEM.marketId })
  //     navigate(SUBITEM.gameId + '/' + SUBITEM.marketId)
  //     sendEvent('GET_SPORTS_DETAILS', { eventId: SUBITEM.gameId, marketId: SUBITEM.marketId })
  // }

  // Scroll the clicked odds element to ~60px from the top so the bet box never covers it
  const scrollToOddsElement = (el: HTMLElement | null) => {
    if (!el) return;
    // Use closest li / parent row as the scroll target so the market title is visible
    const target = (el.closest("li") || el.closest(".position-relative") || el) as HTMLElement;
    const rect = target.getBoundingClientRect();
    const OFFSET_FROM_TOP = 60; // px from viewport top
    const scrollBy = rect.top - OFFSET_FROM_TOP;
    window.scrollBy({ top: scrollBy, behavior: "smooth" });
  };

  const BetClick = (
    ITEM:
      | DetailsTableInterface
      | PreMainInterface
      | FancyInterface
      | PreSubInterface,
    TD: string,
    TABLE: string,
    _T4MAIN: any = undefined,
    _el: HTMLElement | null = null
  ) => {
    if (detailSport?.__preview) return;
    resetBet();
    dispatch({
      type: "GET_SPORTS_LIVE_CALC",
      payload: { calcOntime: false, calcData: {} },
    });
    if (cookies.get("skyTokenFront")) {
      if (TABLE === "t3" && fancyLineClosed(fancyRowStatus(ITEM))) {
        return;
      }
      // console.log("clicked Table", TD, ITEM);
      setClickedBet(TABLE === "t3" ? { ...ITEM } : ITEM);
      setClickedTableData(TD);
      setClickedTable(TABLE);
      if (TABLE === "t4" && _T4MAIN) {
        setT4Main(_T4MAIN);
      } else setT4Main({});
      // Auto-scroll so the betbox doesn't cover the clicked odds
      if (_el) {
        setTimeout(() => scrollToOddsElement(_el), 50);
      }
    } else {
      if (window.innerWidth > 993) {
        setLoginPopup(true);
      } else {
        window.location.pathname = "/login";
      }
    }
  };

  const pinnedOddsOverMaxBhav = (match: any, runner: any) => {
    const maxBhav = Number(match?.bet_odds_limit?.maxPrice) || 0;
    if (maxBhav <= 0) return false;
    const back = Number(runner?.b1);
    const lay = Number(runner?.l1);
    return (
      (Number.isFinite(back) && back > maxBhav) ||
      (Number.isFinite(lay) && lay > maxBhav)
    );
  };

  const openPinnedBet = (
    e: React.MouseEvent,
    runner: any,
    side: string,
    match: any,
    suspended: boolean
  ) => {
    e.stopPropagation();
    if (suspended || pinnedOddsOverMaxBhav(match, runner)) return;
    betMatchRef.current = {
      _id: match?._id,
      type: match?.type,
      gameId: match?.gameId,
      marketId: match?.marketId,
      runners: Array.isArray(match?.t1) ? match.t1 : [],
    };
    BetClick(runner, side, "t1", undefined, e.currentTarget as HTMLElement);
  };

  const resetBet = () => {
    setClickedBet({});
    setClickedTableData("");
    setClickedTable("");
    dispatch({
      type: "GET_SPORTS_LIVE_CALC",
      payload: { calcOntime: false, calcData: {} },
    });
  };
  const OpenCollopsPre = (id: number) => {
    if (openedPre.includes(id)) {
      let openedPreCopy = openedPre;
      openedPreCopy = openedPre.filter((_: number) => _ !== id);
      setOpenedPre(openedPreCopy);
    } else {
      setOpenedPre([...openedPre, id]);
    }
  };

  const isAccordionOpen = (item: PreMainInterface, visibleIndex: number): boolean => {
    const key = String(item.id || item.marketId || item.sortPriority || visibleIndex);
    if (toggledAccordions[key] !== undefined) {
      return toggledAccordions[key];
    }
    return visibleIndex < 9;
  };

  const toggleAccordion = (item: PreMainInterface, visibleIndex: number) => {
    const key = String(item.id || item.marketId || item.sortPriority || visibleIndex);
    const currentlyOpen = isAccordionOpen(item, visibleIndex);
    setToggledAccordions((prev) => ({
      ...prev,
      [key]: !currentlyOpen,
    }));
  };
  const getBetTYPE = (TABLE: string) => {
    switch (TABLE) {
      case "t1":
        return "odds";
      case "t2":
        return "bookMark";
      case "t3":
        return "session";
      case "t4":
        return "premium";
      default:
        break;
    }
  };
  const getSecondValue = (FIRST: string) => {
    switch (FIRST) {
      case "b1":
        return "bs1";
      case "b2":
        return "bs2";
      case "b3":
        return "bs3";
      case "l1":
        return "ls1";
      case "l2":
        return "ls2";
      case "l3":
        return "ls3";
      default:
        return "bs1";
    }
  };
  const getBetSide = (TABLE: string, TYPE: string) => {
    let B = ["b1", "b2", "b3"];
    let L = ["l1", "l2", "l3"];
    if (TABLE === "t4") {
      return "back";
    }
    if (TABLE === "t1" || TABLE === "t2") {
      if (B.includes(TYPE)) {
        return "back";
      }
      if (L.includes(TYPE)) {
        return "lay";
      }
    }
    if (TABLE === "t3") {
      return TYPE === "b1" ? "yes" : "no";
    }
  };

  const PlaceBat = async (
    ITEM: any,
    TotalAmount: any,
    SelectedAmount: number,
    TABLE: string,
    TABLE_DATA: string,
    retundData: boolean = false
  ) => {
    // console.log("::::::-----I", ITEM);
    // console.log("::::::-----P", detailSport);
    let B = ["b1", "b2", "b3"];
    let L = ["l1", "l2", "l3"];
    let WS: any = [];
    let loaderTimer: ReturnType<typeof setTimeout> | null = null;
    if (retundData === false) {
      setPlaceBetLoader(true);
      loaderTimer = setTimeout(() => {
        setPlaceBetLoader(false);
      }, 5000);
    }

    const listBet = isMultiMarketListPage ? betMatchRef.current : null;
    const sameId = (left: any, right: any) =>
      String(left ?? "") !== "" && String(left) === String(right);
    const asNumber = (value: any, fallback = 0) => {
      const n = Number(value);
      return Number.isFinite(n) ? n : fallback;
    };
    const liveT1 = listBet?.runners || detailSport?.page?.data?.t1;
    const liveT2 = detailSport?.page?.data?.t2;
    const liveT4 = detailSport?.pre?.data?.t4;

    let runner = ITEM;
    let premiumMarket = t4Main;
    if (TABLE === "t1" && Array.isArray(liveT1)) {
      runner = liveT1.find((row: any) => sameId(row?.sId, ITEM?.sId)) || ITEM;
    } else if (TABLE === "t2" && Array.isArray(liveT2)) {
      runner = liveT2.find((row: any) => sameId(row?.sId, ITEM?.sId)) || ITEM;
    } else if (TABLE === "t4" && Array.isArray(liveT4)) {
      premiumMarket =
        liveT4.find((market: any) => sameId(market?.id, t4Main?.id)) ||
        liveT4.find((market: any) =>
          (market?.sub_sb || []).some((sub: any) => sameId(sub?.sId, ITEM?.sId))
        ) ||
        t4Main;
      runner =
        (premiumMarket?.sub_sb || []).find((sub: any) =>
          sameId(sub?.sId, ITEM?.sId)
        ) || ITEM;
    }

    if (TABLE === "t1" && Array.isArray(liveT1)) {
      liveT1.forEach((element: DetailsTableInterface) => {
        WS.push(element.nat);
      });
    } else if (TABLE === "t2" && Array.isArray(liveT2)) {
      liveT2.forEach((element: DetailsTableInterface) => {
        WS.push(element.nat);
      });
    }
    if (TABLE === "t3") {
      WS = [ITEM.nat];
    }
    if (TABLE === "t4") {
      (premiumMarket?.sub_sb || []).forEach((element: DetailsTableInterface) => {
        WS.push(element.nat);
      });
    }
    let second = getSecondValue(TABLE_DATA);
    const stake = asNumber(SelectedAmount);
    const profit = asNumber(parseFloat(TotalAmount));
    // "odds", "bookMark", "session", "premium"
    let data: any = {
      api: USER_API.PLACE_BET,
      value: {
        type: listBet?.type || detailSport?.matchInfo?.type, // from match info
        matchId: listBet?._id || detailSport?.matchInfo?._id,
        betType: getBetTYPE(TABLE), //t1 ods //t2 bookmaker //t3 session //t4 premium
        betSide: getBetSide(TABLE, TABLE_DATA), // back lay // fancy- yes no // Pre - back
        selection: TABLE === "t4" ? premiumMarket?.marketName : runner?.nat,
        betPlaced: stake,
        stake,
        oddsUp: asNumber(runner?.[TABLE_DATA], asNumber(ITEM?.[TABLE_DATA])),
        oddsDown: TABLE === "t4" ? 0 : asNumber(runner?.[second], asNumber(ITEM?.[second])),
        profit,
        exposure: L.includes(TABLE_DATA) ? profit : stake,
        winnerSelection: WS, //  array or name string
        sId: TABLE === "t4" ? premiumMarket?.id : runner?.sId ? runner.sId : "",
        pId: TABLE === "t4" ? runner?.sId : "",
        position: TABLE === "t4" ? "" : TABLE_DATA,
        domain: window.location.hostname,
      },
    };
    if (TABLE === "t3") {
      data.value.type = detailSport.matchInfo.type;
      data.value.matchId = detailSport.matchInfo._id;
      data.value.betType = getBetTYPE(TABLE);
      data.value.betSide = getBetSide(TABLE, TABLE_DATA);
      data.value.selection = ITEM.nat;
      data.value.betPlaced = SelectedAmount;
      data.value.stake = SelectedAmount;
      data.value.oddsUp = ITEM[TABLE_DATA];
      data.value.oddsDown = ITEM[second];
      data.value.profit = parseFloat(TotalAmount);
      data.value.exposure = L.includes(TABLE_DATA)
        ? parseFloat(TotalAmount)
        : SelectedAmount;
      data.value.winnerSelection = [ITEM.nat];
      data.value.sId = ITEM.sId ? ITEM.sId : "";
      data.value.pId = "";
      data.value.position = TABLE_DATA;
      data.value.domain = window.location.hostname;
      data.value.fancyYes = ITEM.b1;
      data.value.fancyNo = ITEM.l1;
    }
    if (TABLE === "t4") {
      data.value.subSelection = runner?.nat;
    }

    if (retundData) {
      let data1: any = {};
      data1.eventId = listBet?.gameId
        ? Number(listBet.gameId)
        : eventId
          ? parseInt(eventId)
          : eventId;
      data1.marketId = listBet?.marketId || marketId;
      data1.domain = window.location.hostname;
      sendEvent("GET_SPORTS_DETAILS", data1);
      return data.value;
    }

    // console.log("placeBet data ::::::-----", data);

    if (TABLE === "t3" && fancyLineClosed(fancyRowStatus(ITEM))) {
      if (loaderTimer) clearTimeout(loaderTimer);
      notifyError(fancyClosedMessage(fancyRowStatus(ITEM)));
      setPlaceBetLoader(false);
      return;
    }

    await postApi(data)
      .then(function (response) {
        if (loaderTimer) clearTimeout(loaderTimer);
        // console.log("bet response::::::::::>>>>", response);
        if (!isMultiMarketListPage) {
          setPageData(response.data.data);
        }
        // Update header balance/exposure immediately from API (don't wait for socket)
        const wallet = response?.data?.data;
        if (
          wallet &&
          (wallet.balance !== undefined || wallet.exposure !== undefined)
        ) {
          dispatch({
            type: "UPDATE_USER_BALANCE",
            payload: {
              balance:
                wallet.balance !== undefined
                  ? Number(wallet.balance).toFixed(2)
                  : undefined,
              exposure:
                wallet.exposure !== undefined
                  ? Number(wallet.exposure).toFixed(2)
                  : undefined,
              remaining_balance:
                wallet.remaining_balance !== undefined
                  ? Number(wallet.remaining_balance).toFixed(2)
                  : undefined,
            },
          });
        }
        notifyMessage("Bet Placed");
        setPlaceBetLoader(false);
        bethistory();
        setTimeout(() => {
          sendEvent("UPDATE_USER_BALANCE", { userId: HeaderData?._id });
        }, 500);
        setTimeout(() => {
          sendEvent("UPDATE_USER_BALANCE", { userId: HeaderData?._id });
        }, 1500);

        resetBet();
      })
      .catch((err) => {
        if (loaderTimer) clearTimeout(loaderTimer);
        notifyError(err?.response?.data?.message || "Bet placement failed");
        setPlaceBetLoader(false);
        if (err?.response?.data?.statusCode === 401) {
          Logout();
          // navigate('/login')
        }
      }).finally(() => {
        if (loaderTimer) clearTimeout(loaderTimer);
        setPlaceBetLoader(false)
      });
    // resetBet()
  };

  // const pinMetch = async (e: any, item: PinInterface, type: string) => {
  //     if (isAuthenticated && cookies.get('skyTokenFront')) {

  //         let data = {
  //             api: USER_API.PIN,
  //             value: {
  //                 sportId: item._id,
  //                 type: type,
  //                 flag: false
  //             }
  //         }

  //         await postApi(data).then(function (response) {
  //             getPageData(tab)
  //             notifyMessage('Pin Success')
  //         }).catch(err => {
  //             console.log(err);
  //             if (err.response.data.statusCode === 401) {
  //                 Logout()
  //                 notifyError('Pin unsuccess')
  //                 // navigate('/login')
  //             }
  //         })
  //     } else {
  //         notifyError('please login first')
  //     }
  // }

  const getVideoUrl = async () => {
    setTimeout(() => {
      sendEvent("GET_SCORE_ID", { gameId: eventId });
    }, 1200);

    // https://multiexch.com/VRN/v1/api/scoreid/get?eventid=(bfeventid)
    // https://multiexch.com/VRN/v1/api/scoreid/get?eventid=32353856
    let data = {
      // api: `https://new.livingstreamvdo.com/?eventId=${eventId}`,
      api: `https://liveapi247.com/api1/livestreaming`,
      value: {
        eventid: eventId,
        // eventid: 31846646
      },
    };

    await postApiLink(data)
      .then(function (response) {
        // console.log("::::::::::>>>>api123", response);
        setVideoDetails(response.data[0]);
      })
      .catch((err) => {
        console.log("::::::::::>>>>", err);
        if (err?.response?.data?.statusCode === 401) {
          Logout();
          // navigate('/login')
        }
      });
  };


  const closePositonPopup = () => {
    setPositonModal(false);
  };
  useEffect(() => {
    if (cookies.get("skyTokenFront")) {
      bethistory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const bethistory = async () => {
    let data = {
      api: USER_API.BET_LIST,
      value: {},
    };

    await postApi(data)
      .then(function (response) {
        // setPageData(response.data.data)
        dispatch({ type: "USER_BET_HISTORY", payload: response.data.data });
        setHistorySuccess(true);
      })
      .catch((err) => {
        if (err?.response?.data?.statusCode === 401) {
          Logout();
          // navigate('/login')
        }
      });
  };

  // const onBookClick = (ITEM: any, HISTORY: any) => {

  //     let filterHistory = BET_HISTORY.filter((_: any) => _.selection === ITEM.nat)
  //     let popupdata = bookExposerGetPopup(filterHistory)
  //     let data = [{ main: HISTORY.oddsUp - 1, second: -10 }, { main: HISTORY.oddsUp, second: 10 }, { main: HISTORY.oddsUp + 1, second: 10 }]
  //     setPositonDetails(popupdata)
  //     setPositonModal(true)
  // }

  const [fancyInfoModal, setFancyInfoModal] = useState(false);
  const [premiumInfoModal, setPremiumInfoModal] = useState(false);
  const [showBookmaker, setShowBookmaker] = useState(true);
  const [sportWidgetFlage, setSportWidgetFlage] = useState(true);

  const [mareketDept, setMareketDept] = useState(false);

  const handleNavigation = (item: any) => {
    window.location.pathname = `/multimarket/${item.gameId}/${item.marketId}`;
  };

  const handleMarketDepth = () => {
    setMareketDept(true);
  };


  const [sparkOddsBackDetail, setSparkOddsBackDetail] = useState(0);
  const [sparkOddsLayDetail, setSparkOddsLayDetail] = useState(1);
  const [sparkBookBackDetail, setSparkBookBackDetail] = useState(1);
  const [sparkBookLayDetail, setSparkBookLayDetail] = useState(0);
  const randomeNumber = () => Math.floor((Math.random() * 2));
  useEffect(() => {
    const sparkInterval = setInterval(() => {
      if (typeof document !== "undefined" && document.visibilityState === "hidden") {
        return;
      }
      setSparkOddsBackDetail(randomeNumber())
      setSparkOddsLayDetail(randomeNumber())
      setSparkBookBackDetail(randomeNumber())
      setSparkBookLayDetail(randomeNumber())
      setTimeout(() => {
        setSparkOddsBackDetail(-1)
        setSparkOddsLayDetail(-1)
        setSparkBookBackDetail(-1)
        setSparkBookLayDetail(-1)
      }, 1000)
    }, 5000)
    return () => clearInterval(sparkInterval);
  }, [])

  const liveStrip = useMemo(() => {
    const runners = Array.isArray(detailSport?.page?.data?.t1)
      ? [...detailSport.page.data.t1].sort(
        (a, b) => (a?.sortPriority ?? 0) - (b?.sortPriority ?? 0)
      )
      : [];
    const teamNames = runners
      .map((runner) => runner?.nat)
      .filter((name) => name && !/^the draw$/i.test(String(name)));
    const fromName = splitMatchTeams(detailSport?.matchInfo?.name || "");
    const listed = findListedMatch(
      [cricketList?.res, soccerList?.res, tennisList?.res],
      eventId
    );
    const score1 = listed?.score1;
    const score2 = listed?.score2;
    return {
      left: teamNames[0] || fromName.left,
      right: teamNames[1] || fromName.right,
      score: hasLiveScore(score1, score2) ? `${score1} - ${score2}` : "",
    };
  }, [detailSport, cricketList, soccerList, tennisList, eventId]);

  useEffect(() => {
    const type = String(detailSport?.matchInfo?.type || "").toLowerCase();
    const sportType = type.includes("tennis")
      ? "tennis"
      : type.includes("soccer") || type.includes("football")
        ? "soccer"
        : type.includes("cricket")
          ? "cricket"
          : "";
    if (!sportType || !eventId || !cookies.get("skyTokenFront")) return;

    const pullScores = () => {
      if (typeof document !== "undefined" && document.visibilityState === "hidden") {
        return;
      }
      sendEvent("GET_SPORTS", { type: sportType });
    };
    pullScores();
    const timer = setInterval(pullScores, 10000);
    return () => clearInterval(timer);
  }, [detailSport?.matchInfo?.type, eventId]);

  useEffect(() => {
    setSportsId(
      sportStreamId(
        detailSport?.matchInfo?.type || SPORT_DETAILS?.matchInfo?.type || ""
      )
    );
  }, [detailSport?.matchInfo?.type, SPORT_DETAILS?.matchInfo?.type]);

  useEffect(() => {
    setLiveTvUrl("");
    setLiveScoreUrl("");
  }, [eventId]);

  // The sport id arrives after the match details. An unchanged address keeps the player
  // instead of reloading it, and TV never waits for the score lookup.
  useEffect(() => {
    if (!eventId) return;
    let cancelled = false;
    const value = { eid: eventId, sportId: sportsId };
    postApi({ api: "tv", value })
      .then((tv: any) => {
        if (cancelled) return;
        const nextTv = String(tv?.data?.data?.url || "");
        setLiveTvUrl((prev) => (prev === nextTv ? prev : nextTv));
      })
      .catch((error: any) => console.error("Error fetching live tv:", error));
    postApi({ api: "scoreboard", value })
      .then((score: any) => {
        if (cancelled) return;
        const nextScore = String(score?.data?.data?.url || "");
        setLiveScoreUrl((prev) => (prev === nextScore ? prev : nextScore));
      })
      .catch((error: any) => console.error("Error fetching scoreboard:", error));
    return () => {
      cancelled = true;
    };
  }, [eventId, sportsId]);

  useEffect(() => {
    setScoreCardHeight(DEFAULT_SCORE_CARD_HEIGHT);
  }, [eventId, openLive]);

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      const data = event?.data;
      if (
        !data ||
        typeof data !== "object" ||
        typeof data.height !== "number" ||
        Number.isNaN(data.height) ||
        data.height < 50 ||
        data.height > 2500
      ) {
        return;
      }

      const scoreSrc = liveScoreUrl;
      if (scoreSrc) {
        try {
          if (event.origin !== new window.URL(scoreSrc).origin) return;
        } catch {
          if (!/oddstrad\.com|scorecard|sbexlive\.com|glivesport\.live/i.test(event.origin || "")) return;
        }
      } else if (!/oddstrad\.com|scorecard|sbexlive\.com|glivesport\.live/i.test(event.origin || "")) {
        return;
      }

      const next = Math.ceil(data.height);
      if (next > DEFAULT_SCORE_CARD_HEIGHT + SCORE_CARD_EXPAND_THRESHOLD) {
        setScoreCardHeight(next);
      } else {
        setScoreCardHeight(DEFAULT_SCORE_CARD_HEIGHT);
      }
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [liveScoreUrl, sportsId, eventId]);

  const tvIframeSrc = liveTvUrl;
  const scoreIframeSrc = liveScoreUrl;
  const isScoreError = !scoreIframeSrc;
  const scoreFrame = (
    <div className="cst_live_tv_section score_card" style={{ padding: 0, marginBottom: 0, position: 'relative', width: '100%', height: scoreCardHeight, overflow: "hidden" }}>
      {isScoreError ? (
        <div style={{
          width: '100%',
          height: '100%',
          backgroundColor: '#f5f5f5',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px'
        }}>
          <img src="/images/no-data.png" alt="No score card available" />
        </div>
      ) : (
        <iframe
          title="scoreboard"
          src={scoreIframeSrc}
          sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
          allow="autoplay"
          width="100%"
          height={scoreCardHeight}
          style={{
            border: "none",
            display: "block",
            overflow: "hidden",
            backgroundColor: "#1e1e1e",
            height: `${scoreCardHeight}px`,
          }}
          scrolling="no"
        ></iframe>
      )}
    </div>
  );

  // console.log("detailSport", detailSport);

  if (isMultiMarketListPage) {
    // console.log("pageData::: ", pageData?.list[0]?.pin)
    return (

      <div className="multi-market-list-page" style={{ minHeight: '100vh', padding: "0.5rem" }}>
        {isLoadingMain && <Loader />}
        {!isLoadingMain && pageData?.list[0]?.pin?.length > 0 ? (
          <div className="pinned-market-list">
            {pageData.list[0].pin.map((item: any, index: number) => {
              const runners = Array.isArray(item?.t1) ? item.t1 : [];

              // Don't render if t1 is empty array
              if (!Array.isArray(item?.t1) || item?.t1?.length === 0) {
                return null;
              }

              const matched = runners[0]?.totalmatch;
              const collapsed = !!collapsedPins[String(item?._id || index)];
              const openMatch = () => {
                localStorage.setItem("sportsName", item?.name || "");
                localStorage.setItem("sportsData", JSON.stringify(item));
                navigate(`/multimarket/${item.gameId}/${item.marketId}`);
              };
              return (
                <div className="pinned-match-card" key={item?._id || index} style={{ marginBottom: "0.5rem", borderRadius: "0.5rem", padding: "0 3px" }}>
                  <style>
                    {`
                    .pinned-odds-bar {
    padding: 9px 8px 9px 6px;
    border-radius: 0.5rem 0.5rem 0 0;
}
`}
                  </style>
                  <button type="button" className="pinned-match-title" onClick={openMatch} style={{ padding: "9px 0.5rem", fontSize: "13.52px" }}>
                    <span>{item?.name}</span>
                    <svg viewBox="0 0 256 512" width="14" height="14" aria-hidden="true">
                      <path fill="currentColor" d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z" />
                    </svg>
                  </button>
                  <div className="pinned-odds-bar">
                    <button
                      type="button"
                      className="pinned-star"
                      aria-label="Unpin match"
                      onClick={(e) => unpinMatch(e, item)}
                    >
                      <svg viewBox="0 0 1024 1024" width="16" height="16" aria-hidden="true">
                        <path fill="currentColor" d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" />
                      </svg>
                    </button>
                    <span className="pinned-odds-name" style={{ fontSize: "14.56px", fontWeight: 400 }}>Match Odds</span>
                    {matched != null && matched !== "" && (
                      <span className="pinned-matched" style={{ fontSize: "10.4px", fontWeight: 400, color: "#1E1E1E", opacity: 0.4 }}>
                        Matched <b style={{ fontWeight: 700 }}>{Number(matched).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                      </span>
                    )}
                    <button
                      type="button"
                      className={`pinned-collapse${collapsed ? " is-collapsed" : ""}`}
                      aria-label="Toggle odds"
                      onClick={() =>
                        setCollapsedPins((prev) => ({
                          ...prev,
                          [String(item?._id || index)]: !prev[String(item?._id || index)],
                        }))
                      }
                    >
                      <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                        <path fill="currentColor" d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
                      </svg>
                    </button>
                  </div>
                  {!collapsed && (
                    <>
                      <div className="pinned-odds-labels">
                        <span style={{ fontSize: "10.4px", fontWeight: 400, width: "16.66%" }}>Back</span>
                        <span style={{ fontSize: "10.4px", fontWeight: 400, width: "16.66%" }}>Lay</span>
                      </div>
                      {runners.map((runner: any, runnerIndex: number) => {
                        const hold = item?.oddsSuspended === true
                          ? "Suspended"
                          : oddsHoldText(runner?.status);
                        const suspended = Boolean(hold);
                        const overMaxBhav = !suspended && pinnedOddsOverMaxBhav(item, runner);
                        const flashId = `${item?._id || item?.gameId}-${runner?.sId ?? runnerIndex}`;
                        return (
                          <div className="pinned-runner" key={runner?.sId || runnerIndex}>
                            <span className="pinned-runner-name" style={{ fontSize: "13.52px", width: "75%" }}>{runner?.nat}</span>
                            <div className={`pinned-prices${suspended ? " is-suspended" : ""}${overMaxBhav ? " is-maxprice" : ""}`} style={{ width: "33.33%" }}>
                              {suspended && <span className="pinned-suspend" style={{ color: "#fff", fontSize: "11.44px", fontWeight: 400 }}>{hold}</span>}
                              <div
                                className={`pinned-price back${oddsFlash[`${flashId}:back`] ? " spark-back" : ""}${clickedBet?.sId === runner?.sId && clickedTableData === "b1" ? " back-active" : ""}`}
                                onClick={(e) => openPinnedBet(e, runner, "b1", item, suspended)}
                                style={item?.oddsSuspended === true || !(Number(item?.bet_odds_limit?.min) <= Number(runner?.b1) && Number(item?.bet_odds_limit?.max) >= Number(runner?.b1)) ? { pointerEvents: "none" } : {}}
                              >
                                <strong>{runner?.b1}</strong>
                                <small>{runner?.bs1}</small>
                              </div>
                              <div
                                className={`pinned-price lay${oddsFlash[`${flashId}:lay`] ? " spark-lay" : ""}${clickedBet?.sId === runner?.sId && clickedTableData === "l1" ? " lay-active" : ""}`}
                                onClick={(e) => openPinnedBet(e, runner, "l1", item, suspended)}
                                style={item?.oddsSuspended === true || !(Number(item?.bet_odds_limit?.min) <= Number(runner?.l1) && Number(item?.bet_odds_limit?.max) >= Number(runner?.l1)) ? { pointerEvents: "none" } : {}}
                              >
                                <strong>{runner?.l1}</strong>
                                <small>{runner?.ls1}</small>
                              </div>
                              {item.status !== "SUSPEND" &&
                                Number(item?.bet_odds_limit?.maxPrice ?? 0) > 0 &&
                                (Number(runner?.b1) > Number(item.bet_odds_limit?.maxPrice) ||
                                  Number(runner?.l1) > Number(item.bet_odds_limit?.maxPrice)) && (
                                  <div
                                    className="maxprice-exceeded"
                                    aria-label="Maximum odds price exceeded"
                                    title="Maximum odds price exceeded"
                                    style={{
                                      position: "absolute",
                                      inset: 0,
                                      zIndex: 5,
                                      background: "#6f8898",
                                      opacity: 0.8,
                                      cursor: "not-allowed",
                                      width: "100%",
                                      borderRadius: "6px"
                                    }}
                                  />
                                )}
                            </div>
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <div className="no-event-outer">
            <div className="no-event">
              <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" color="lightgrey" className="mb-2" height="55" width="55" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"></path>
              </svg>
              No Event
            </div>
          </div>
        )}
        {clickedTableData.length > 0 && (
          <BetBox
            resetClicked={resetBet}
            placeBetClicked={PlaceBat}
            clickedBet={clickedBet}
            clickedTable={clickedTable}
            clickedTableData={clickedTableData}
            setPlaceBetLoader={setPlaceBetLoader}
            placeBetLoader={placeBetLoader}
            stackManage={manageStack}
          />
        )}
      </div>
    );
  }

  return (

    <div style={{ paddingBottom: "95px" }}>
      {isLoadingMain && !isPreview && <Loader />}
      {/* {placeBetLoader && (
        <div className="loader_top">
          {" "}
          <Loader />{" "}
        </div>
      )} */}

      <style>
        {`
        .slick-track {
            margin-left: 0 !important;
          }
  /* =========================
     LIVE TV - NORMAL STATE
     ========================= */

  .cst_live_tv_wrapper {
    position: relative;
    width: 100%;
  }

  .cst_live_tv_placeholder {
    width: 100%;
    height: 206px;
    background: #000;
  }

  .live_tv {
    position: relative;
    width: 100%;
    height: 206px;
    overflow: hidden;
    background: #000;
    z-index: 20;
  }

  .live_tv iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }


  /* =========================
     MINI FLOATING TV
     ========================= */

  .live_tv.live-tv-mini {
    position: fixed;
    width: 50vw;
    height: 28.125vw;

    min-height: 0 !important;

    background: #000;
    border-radius: 4px;

    overflow: visible;

    z-index: 99999;

    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.45), 0 2px 8px rgba(0, 0, 0, 0.3);

    animation: liveTvMiniIn 0.22s cubic-bezier(0.16, 1, 0.3, 1);
    will-change: transform, opacity;
  }

  /* While dragging, disable all transitions and iframe pointer interception */
  .live_tv.is-dragging {
    transition: none !important;
    animation: none !important;
    cursor: grabbing !important;
    user-select: none !important;
  }

  .live_tv.is-dragging iframe {
    pointer-events: none !important;
  }

  .live_tv.is-dragging .mini-tv-header,
  .live_tv.is-dragging .mini-tv-drag-icon {
    cursor: grabbing !important;
  }


  /* =========================
     MINI TV HEADER / DRAG AREA
     ========================= */

  .mini-tv-header {
    position: absolute;

    top: 0;
    left: 0;

    width: 100%;
    height: 28px;

    display: flex;
    align-items: center;

    padding: 0 0;

    color: #fff;

    z-index: 2;

    cursor: grab;

    user-select: none;

    touch-action: none;
  }

  .mini-tv-header:active {
    cursor: grabbing;
  }

  .mini-tv-drag-icon {
    font-size: 14px;
    line-height: 1;
    position: absolute;
    right: -12px;
    top: -12px;
    opacity: 1;
    width: 24px;
    height: 24px;
    cursor: grab;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mini-tv-title {
    
  flex: 1;

    font-size: 11px;
    font-weight: 600;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .leading-normal span {
    font-size: 10.4px !important;
}


  /* =========================
     CLOSE BUTTON
     ========================= */

  .mini-tv-close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 2px;
    top: 2px;

    padding: 0;
    margin: 0;

    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);

    color: #fff;

    font-size: 12px;
    line-height: 18px;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    flex-shrink: 0;
    z-index: 3;
    transition: background 0.15s ease;
  }

  .mini-tv-close:hover {
    background: rgba(220, 38, 38, 0.85);
  }


  /* =========================
     MINI IFRAME
     ========================= */

  .live_tv.live-tv-mini iframe {
    position: absolute;

    left: 0;
    top: 0px;

    width: 100%;
    height: 100%;

    min-height: 0 !important;
  }

  .fullmarket .fancy-sport-tab .sport-listing .accordion-header {
    margin-bottom: 0.125rem;
}

.fullmarket .fancy-sport-tab .sport-listing h2 button {
    border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
  .fullmarket .fancy-sport-tab .sport-listing .row div:nth-child(n) {
    padding-right: 0.125rem;
}

.fullmarket .fancy-sport-tab .sport-listing .team-wise-score {
    margin-bottom: 0.125rem;
}
    .fullmarket .fancy-sport-tab .sport-listing .team-wise-score {
    padding: .375rem 0 !important;
}


  /* =========================
     ANIMATION
     ========================= */

  @keyframes liveTvMiniIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }

    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`}
      </style>

      <div className="fullmarket" style={{ background: "#EEF6FB" }}>
        <div
          className={` ${cookies.get("skyTokenFront") ? "live_match" : ""} `}
        >
          {cookies.get("skyTokenFront") && (
            <div className="topnav">
              <p
                className={`${openLive === "live" ? "active" : ""}`}
                onClick={() => setopenLive("live")}
              >
                Live
              </p>
              <p
                className={`${openLive === "scoreboard" ? "active" : ""}`}
                onClick={() => setopenLive("scoreboard")}
              >
                Scoreboard
              </p>
            </div>
          )}
          <div>
            {cookies.get("skyTokenFront") ? (
              <>
                {openLive === "scoreboard" && scoreFrame}
                {/* Hidden, not removed, on the scoreboard tab so the player does not reload. */}
                <div style={{ display: openLive === "scoreboard" ? "none" : "block" }}>
                  {(liveStrip.left || liveStrip.right) && (
                    <div className="live-header">
                      <span className="live-team left">{liveStrip.left}</span>
                      <span className="live-score">{liveStrip.score}</span>
                      <span className="live-team right">{liveStrip.right}</span>
                    </div>
                  )}
                  {/^https?:\/\//i.test(tvIframeSrc) ? (
                    <div className="cst_live_tv_wrapper">
                      {isTvMini && !isTvClosed && (
                        <div className="cst_live_tv_placeholder" />
                      )}
                      <div
                        ref={tvContainerRef}
                        className={`cst_live_tv_section live_tv ${isTvMini ? "live-tv-mini" : ""
                          } ${isTvClosed ? "live-tv-closed" : ""}`}
                        style={
                          isTvMini
                            ? {
                              left: `${tvPosition.x}px`,
                              top: `${tvPosition.y}px`,
                            }
                            : undefined
                        }
                      >
                        {isTvMini && (
                          <div
                            className="mini-tv-header"
                            onPointerDown={handleTvPointerDown}
                          >
                            <span className="mini-tv-drag-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M342.6 73.4C330.1 60.9 309.8 60.9 297.3 73.4L233.3 137.4C224.1 146.6 221.4 160.3 226.4 172.3C231.4 184.3 243.1 192 256 192L288 192L288 288L192 288L192 256C192 243.1 184.2 231.4 172.2 226.4C160.2 221.4 146.5 224.2 137.3 233.3L73.3 297.3C60.8 309.8 60.8 330.1 73.3 342.6L137.3 406.6C146.5 415.8 160.2 418.5 172.2 413.5C184.2 408.5 192 396.9 192 384L192 352L288 352L288 448L256 448C243.1 448 231.4 455.8 226.4 467.8C221.4 479.8 224.2 493.5 233.3 502.7L297.3 566.7C309.8 579.2 330.1 579.2 342.6 566.7L406.6 502.7C415.8 493.5 418.5 479.8 413.5 467.8C408.5 455.8 396.9 448 384 448L352 448L352 352L448 352L448 384C448 396.9 455.8 408.6 467.8 413.6C479.8 418.6 493.5 415.8 502.7 406.7L566.7 342.7C579.2 330.2 579.2 309.9 566.7 297.4L502.7 233.4C493.5 224.2 479.8 221.5 467.8 226.5C455.8 231.5 448 243.1 448 256L448 288L352 288L352 192L384 192C396.9 192 408.6 184.2 413.6 172.2C418.6 160.2 415.8 146.5 406.7 137.3L342.7 73.3z" /></svg>
                            </span>

                            <button
                              type="button"
                              className="mini-tv-close"
                              onClick={(e) => {
                                e.stopPropagation();
                                setIsTvClosed(true);
                                setIsTvMini(false);
                              }}
                              aria-label="Close live TV"
                            >
                              ×
                            </button>
                          </div>
                        )}

                        {!isTvClosed && (
                          <iframe
                            title="live-tv"
                            style={{
                              minHeight: isTvMini ? "100%" : "206px",
                              height: "100%",
                              width: "100%",
                              overflow: "hidden",
                              border: "none",
                              display: "block",
                            }}
                            className="cst_live_tv responsive-iframe w-100"
                            id="Iframe"
                            src={tvIframeSrc}
                            width="100%"
                            scrolling="no"
                            allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
                            allowFullScreen
                          ></iframe>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="cst_live_tv_section live_tv">
                      <img src="/images/tv_img.jpg" alt="tv_image" />
                    </div>
                  )}
                </div>
              </>
            ) : (
              scoreFrame
            )}
          </div>
        </div>

        {!blockStatus?.blockAll &&
          !blockStatus?.blockOdds &&
          detailSport?.page?.data?.t1?.length > 0 ? (
          <>
            <div className="balance-label-detail position-relative text-start d-flex justify-content-between exchange-label">
              <span style={{ fontWeight: 400, fontSize: "1rem" }}>Exchange</span>
              <div className="text-yellow balance-label-inner">
                <span style={{ fontSize: "10.42px", fontWeight: 400 }}>Matched</span>
                <strong style={{ fontSize: "10.42px", paddingLeft: "0.3rem", paddingRight: "0" }}>
                  {detailSport?.page?.data?.t1[0]?.totalmatch}
                </strong>
              </div>
            </div>
            <div className="match-odds-sec">
              <div className="bg-yellow d-flex match-odd-header-outer ">
                <div className=" d-flex align-items-center match-odd-header-text match-odd-header" style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "4px", fontSize: "1rem", fontWeight: "800" }}>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 1024 1024"
                    height="20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"></path>
                  </svg>
                  Match Odds
                </div>
              </div>
              <div className="match-odd-table bg-white p-3 px-2 pt-1 pb-0">
                <div className="d-flex back-lay-head justify-content-end ms-auto pb-1">
                  <span className="text-center w-100">Back</span>
                  <span className="text-center w-100">Lay</span>
                </div>
                <ul className="rounded position-relative p-0">
                  {detailSport &&
                    stableSort(
                      detailSport?.page?.data?.t1,
                      getComparator("asc", "sortPriority")
                    ).map((item: DetailsTableInterface, i) => {
                      const hold = oddsHoldText(item.status);
                      return (
                        <>
                          <li key={i} style={{ padding: 0 }}>
                            <h2 style={{ paddingLeft: ".625rem", paddingRight: ".625rem" }}>
                              {item.nat}
                              {item?.betProfit &&
                                cookies.get("skyTokenFront") && (
                                  <span className="d-block py-1 team-red-score">
                                    <span
                                      className={` ${item.betProfit < 0
                                        ? "text-danger"
                                        : "text-green"
                                        } team_total`}
                                      style={{ fontSize: "10.4px", lineHeight: "11px" }}
                                    >
                                      {" "}
                                      &gt; (
                                      {parseFloat(item.betProfit)?.toFixed(2)})
                                    </span>
                                  </span>
                                )}
                            </h2>
                            <div className="lay-back-table " style={{ position: "relative" }}>
                              <div
                                onClick={(e) => BetClick(item, "b1", "t1", undefined, e.currentTarget)}
                                id="back_odds_0"
                                className={`${clickedBet?.sId === item.sId &&
                                  clickedTableData === "b1"
                                  ? "back-active"
                                  : ""
                                  } back ${sparkOddsBackDetail === i ? "spark-back" : ""}`}
                                style={(hold ||
                                  !(
                                    detailSport?.matchInfo?.oddsLimit?.min <=
                                    item.b1 &&
                                    detailSport?.matchInfo?.oddsLimit?.max >=
                                    item.b1)) ? { pointerEvents: "none" } : { pointerEvents: "auto" }}
                              >
                                <span
                                  className={`${hold ||
                                    !(
                                      detailSport?.matchInfo?.oddsLimit?.min <=
                                      item.b1 &&
                                      detailSport?.matchInfo?.oddsLimit?.max >=
                                      item.b1
                                    )
                                    ? "single-disabled"
                                    : ""
                                    }`}
                                >
                                  {(hold ||
                                    !(
                                      detailSport?.matchInfo?.oddsLimit?.min <=
                                      item.b1 &&
                                      detailSport?.matchInfo?.oddsLimit?.max >=
                                      item.b1
                                    )) && <span className="disabled"> </span>}
                                  <strong>{item.b1}</strong>
                                  <span className="d-block">{item.bs1}</span>
                                </span>
                              </div>

                              <div
                                onClick={(e) => BetClick(item, "l1", "t1", undefined, e.currentTarget)}
                                id="lay_odds_0"
                                className={`${clickedBet?.sId === item.sId &&
                                  clickedTableData === "l1"
                                  ? "lay-active"
                                  : ""
                                  } lay ${sparkOddsLayDetail === i ? "spark-lay" : ""}`}
                                style={(hold ||
                                  !(
                                    detailSport?.matchInfo?.oddsLimit?.min <=
                                    item.l1 &&
                                    detailSport?.matchInfo?.oddsLimit?.max >=
                                    item.l1)) ? { pointerEvents: "none" } : { pointerEvents: "auto" }}
                              >
                                <span
                                  className={`${hold ||
                                    !(
                                      detailSport?.matchInfo?.oddsLimit?.min <=
                                      item.l1 &&
                                      detailSport?.matchInfo?.oddsLimit?.max >=
                                      item.l1
                                    )
                                    ? "single-disabled"
                                    : ""
                                    }`}
                                >
                                  {(hold ||
                                    !(
                                      detailSport?.matchInfo?.oddsLimit?.min <=
                                      item.l1 &&
                                      detailSport?.matchInfo?.oddsLimit?.max >=
                                      item.l1
                                    )) && <span className="disabled"> </span>}
                                  <strong>{item.l1}</strong>
                                  <span className="d-block">{item.ls1}</span>
                                </span>
                              </div>

                              {!hold &&
                                Number(detailSport?.matchInfo?.bet_odds_limit?.maxPrice ?? 0) > 0 &&
                                (Number(item.b1) > Number(detailSport.matchInfo.bet_odds_limit.maxPrice) ||
                                  Number(item.l1) > Number(detailSport.matchInfo.bet_odds_limit.maxPrice)) && (
                                  <div
                                    className="maxprice-exceeded"
                                    aria-label="Maximum odds price exceeded"
                                    title="Maximum odds price exceeded"
                                    style={{
                                      position: "absolute",
                                      inset: 0,
                                      zIndex: 5,
                                      background: "#6f8898",
                                      opacity: 0.8,
                                      cursor: "not-allowed",
                                      width: "100%"
                                    }}
                                  />
                                )}
                              {hold && (
                                <div className="overlay-match">
                                  {hold}
                                </div>
                              )}
                            </div>
                          </li>
                        </>
                      );
                    })}
                </ul>

                <div className="market-depth-sec d-flex justify-content-end pt-1 justify-content-between items-content-center">
                  {/* <button
                    onClick={() => handleMarketDepth()}
                    className="market-depth-sec-btn inline-flex justify-center items-center rounded bg-secondary text-global-font-on-dark px-3px py-1.5"
                  >
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.0"
                        width="164.000000pt"
                        height="170.000000pt"
                        viewBox="0 0 164.000000 170.000000"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <g
                          transform="translate(0.000000,170.000000) scale(0.100000,-0.100000)"
                          fill="#000000"
                          stroke="none"
                        >
                          <path d="M840 1065 l0 -515 130 0 130 0 0 515 0 515 -130 0 -130 0 0 -515z" />
                          <path d="M160 975 l0 -425 125 0 125 0 0 425 0 425 -125 0 -125 0 0 -425z" />
                          <path d="M1180 890 l0 -340 130 0 130 0 0 340 0 340 -130 0 -130 0 0 -340z" />
                          <path d="M500 805 l0 -255 130 0 130 0 0 255 0 255 -130 0 -130 0 0 -255z" />
                          <path d="M160 250 l0 -130 685 0 685 0 0 130 0 130 -685 0 -685 0 0 -130z" />
                        </g>
                      </svg>
                    </div>
                    <span className="px-3px text-11"> Market Depth </span>
                  </button> */}
                  <div className="d-flex align-items-center min-max">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 256 512"
                      height="14px"
                      width="14px"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"></path>
                    </svg>
                    <span style={{ fontWeight: '600' }}>Min/Max</span>
                    {/* <strong>1/10,000</strong> */}
                    <strong style={{ fontWeight: '600' }}>
                      {detailSport?.matchInfo?.bet_odds_limit?.min}/
                      {detailSport?.matchInfo?.bet_odds_limit?.max}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        {/* { <OddsDammyData detailSport={detailSport} />} */}

        {detailSport?.matchInfo?.activeStatus?.bookmaker &&
          !blockStatus?.blockAll &&
          !blockStatus?.blockBookMaker &&
          detailSport?.page?.data?.t2.length > 0 ? (
          <div className="bookmaker px-2" style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }}>
            <div className="accordion">
              <div className="accordion-item">
                <h2
                  className={`${showBookmaker ? "active" : ""
                    } accordion-header`}
                  onClick={() => setShowBookmaker(!showBookmaker)}
                >
                  <button
                    type="button"
                    aria-expanded="true"
                    className="accordion-button"
                  >
                    <div className="d-flex align-items-center" style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "1rem" }}>
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 1024 1024"
                        height="20"
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"></path>
                      </svg>
                      Bookmaker
                    </div>
                  </button>
                </h2>
                <div
                  className={`${showBookmaker ? "slide-down" : "slide-up"
                    } accordion-collapse `}
                >
                  <div className="p-0 accordion-body">
                    <div className="match-odd-table bg-white p-3 px-2 pt-1 pb-0">
                      <div className="d-flex back-lay-head justify-content-end ms-auto pb-1">
                        <span className="text-center w-100">Back</span>
                        <span className="text-center w-100">Lay</span>
                      </div>
                      <ul className="mb-2 rounded position-relative p-0">
                        {detailSport &&
                          stableSort(
                            detailSport?.page?.data?.t2,
                            getComparator("asc", "sortPriority")
                          ).map((item: DetailsTableInterface, i) => {
                            return (
                              <li key={i}>
                                <h2>{item.nat}
                                  {item?.betProfit &&
                                    cookies.get("skyTokenFront") && (
                                      <span className="d-block py-1 team-red-score">
                                        <span
                                          className={` ${item.betProfit < 0
                                            ? "text-danger"
                                            : "text-green"
                                            } team_total`}
                                        >
                                          {" "}
                                          &gt; (
                                          {parseFloat(item.betProfit)?.toFixed(2)})
                                        </span>
                                      </span>
                                    )}
                                </h2>
                                <div className="lay-back-table bg-bookmaker-market">
                                  <div
                                    id="back_odds_0"
                                    className={`${clickedBet?.sId === item.sId &&
                                      clickedTableData === "b1"
                                      ? "back-active"
                                      : ""
                                      } back ${sparkBookBackDetail === i ? "spark-back" : ""}`}
                                  >
                                    <span
                                      className={`${item.status === "SUSPEND"
                                        ? "single-disabled"
                                        : ""
                                        }`}
                                      onClick={(e) => BetClick(item, "b1", "t2", undefined, e.currentTarget)}
                                    >
                                      {item.status === "SUSPEND" && (
                                        <span className="disabled"> </span>
                                      )}
                                      <strong>{item.b1}</strong>
                                      <span className="d-block">
                                        {item.bs1}
                                      </span>
                                    </span>
                                  </div>
                                  <div
                                    id="lay_odds_0"
                                    className={`${clickedBet?.sId === item.sId &&
                                      clickedTableData === "l1"
                                      ? "lay-active"
                                      : ""
                                      } lay ${sparkBookLayDetail === i ? "spark-lay" : ""}`}
                                  >
                                    <span
                                      className={`${item.status === "SUSPEND"
                                        ? "single-disabled"
                                        : ""
                                        }`}
                                      onClick={(e) => BetClick(item, "l1", "t2", undefined, e.currentTarget)}
                                    >
                                      {item.status === "SUSPEND" && (
                                        <span className="disabled"> </span>
                                      )}
                                      <strong>{item.l1}</strong>
                                      <span className="d-block">
                                        {item.ls1}
                                      </span>
                                    </span>
                                  </div>
                                  {item.status === "SUSPEND" && (
                                    <div className="overlay-match">
                                      Suspended
                                    </div>
                                  )}
                                </div>
                              </li>
                            );
                          })}
                      </ul>
                      <div className="market-depth-sec d-flex justify-content-end">
                        <div className="d-flex align-items-center min-max">
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth="0"
                            viewBox="0 0 256 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"></path>
                          </svg>
                          <span>Min/Max</span>
                          <strong>
                            {detailSport?.matchInfo?.bet_bookmaker_limit?.min}/
                            {detailSport?.matchInfo?.bet_bookmaker_limit?.max}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="fancy-sport-tab px-2 pt-1">
          {!isPreview && (detailSport?.page?.data?.t3?.length ||
            detailSport?.pre?.data?.t4?.length ||
            detailSport?.matchInfo) ? (
            <div className="fancy-sport-header">
              <div className="d-flex align-items-center taber">
                <button
                  type="button"
                  style={{ fontWeight: 400 }}
                  className={` ${activeTab === "fancybet" ? "active-taber" : ""
                    } btn btn-primary`}
                  onClick={() => {
                    setFancyPremium(true);
                    setActiveTab("fancybet");
                  }}
                >
                  Fancybet
                </button>

                <button
                  style={{ fontWeight: 400 }}
                  type="button"
                  className={` ${activeTab === "premiumfancy" ? "active-taber" : ""
                    } btn btn-primary`}
                  onClick={() => {
                    setFancyPremium(false);
                    setActiveTab("premiumfancy");
                  }}
                >
                  Sportsbook
                </button>
              </div>
            </div>
          ) : (
            ""
          )}

          {fancyPremium ? (
            detailSport?.matchInfo?.activeStatus?.fancy &&
              !blockStatus.blockAll &&
              !blockStatus.blockFancy &&
              detailSport?.page?.data?.t3?.length > 0 ? (
              <div
                className="fancy-tab-header sports-tab-panel px-3 fancy-sports-inner-tab position-relative"
                style={{ display: "flex" }}
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 1024 1024"
                  className="mr-2"
                  height="20"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginTop: "2px" }}
                >
                  <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"></path>
                </svg>
                <div
                  style={{
                    position: "relative",
                    width: "70%",
                    minHeight: "31px",
                    display: "flex",
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div
                    className="sports-tab-panel-item"
                    onClick={() => setActiveFancyTab(0)}
                    style={{ cursor: "pointer", padding: "0 10px" }}
                    ref={(el) => (fancyTabsRef.current[0] = el)}
                  >
                    <div>
                      <h3 className={activeFancyTab === 0 ? "selected" : ""}>
                        All
                      </h3>
                    </div>
                  </div>
                  <div
                    className="sports-tab-panel-item"
                    onClick={() => setActiveFancyTab(1)}
                    style={{ cursor: "pointer", padding: "0 10px" }}
                    ref={(el) => (fancyTabsRef.current[1] = el)}
                  >
                    <div>
                      <h3 className={activeFancyTab === 1 ? "selected" : ""}>
                        {" "}
                        Market
                      </h3>
                    </div>
                  </div>
                  <div
                    className="sports-tab-panel-item"
                    onClick={() => setActiveFancyTab(2)}
                    style={{ cursor: "pointer", padding: "0 10px" }}
                    ref={(el) => (fancyTabsRef.current[2] = el)}
                  >
                    <div>
                      <h3 className={activeFancyTab === 2 ? "selected" : ""}>
                        {" "}
                        Bookmakers
                      </h3>
                    </div>
                  </div>
                  <div
                    className=""
                    style={{
                      position: "absolute",
                      left: `${fancyLineStyle.left}px`,
                      bottom: "3px",
                      width: `${fancyLineStyle.width}px`,
                      height: "2px",
                      background: "var(--colorSecond)",
                      transition: "all 0.3s ease-in-out",
                    }}
                  />
                </div>
                <button
                  type="button"
                  style={{ marginLeft: "auto", marginTop: "2px" }}
                  className="end-0 p-1 top-0 info-btn border-0 btn btn-primary"
                  onClick={() => setFancyInfoModal(true)}
                >
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 16 16"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path>
                  </svg>
                </button>
              </div>
            ) : null
          ) : isUserLoggedIn &&
            detailSport?.pre?.data?.t4?.length > 0 &&
            detailSport?.matchInfo?.activeStatus?.premium &&
            !blockStatus.blockAll &&
            !blockStatus.blockPremium ? (
            <div
              className="fancy-tab-header sports-tab-panel px-3 fancy-sports-inner-tab position-relative"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div
                style={{
                  position: "relative",
                  width: "75%",
                  minHeight: "31px",
                  display: "flex",
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                }}
              >
                <div
                  className="sports-tab-panel-item"
                  onClick={() => setActivePremiumTab(0)}
                  style={{ cursor: "pointer", padding: "0 10px" }}
                  ref={(el) => (premiumTabsRef.current[0] = el)}
                >
                  <div>
                    <h3
                      className={activePremiumTab === 0 ? "selected" : ""}
                    >
                      All
                    </h3>
                  </div>
                </div>
                <div
                  className="sports-tab-panel-item"
                  onClick={() => setActivePremiumTab(1)}
                  style={{ cursor: "pointer", padding: "0 10px" }}
                  ref={(el) => (premiumTabsRef.current[1] = el)}
                >
                  <div>
                    <h3
                      className={activePremiumTab === 1 ? "selected" : ""}
                    >
                      {" "}
                      Popular
                    </h3>
                  </div>
                </div>
                <div
                  className="sports-tab-panel-item"
                  onClick={() => setActivePremiumTab(2)}
                  style={{ cursor: "pointer", padding: "0 10px" }}
                  ref={(el) => (premiumTabsRef.current[2] = el)}
                >
                  <div>
                    <h3
                      className={activePremiumTab === 2 ? "selected" : ""}
                    >
                      {" "}
                      Match
                    </h3>
                  </div>
                </div>
                <div
                  className="sports-tab-panel-item"
                  onClick={() => setActivePremiumTab(3)}
                  style={{ cursor: "pointer", padding: "0 10px" }}
                  ref={(el) => (premiumTabsRef.current[3] = el)}
                >
                  <div>
                    <h3
                      className={activePremiumTab === 3 ? "selected" : ""}
                    >
                      {" "}
                      Match
                    </h3>
                  </div>
                </div>
                <div
                  className=""
                  style={{
                    position: "absolute",
                    left: `${premiumLineStyle.left}px`,
                    bottom: "3px",
                    width: `${premiumLineStyle.width}px`,
                    height: "2px",
                    background: "var(--colorSecond)",
                    transition: "all 0.3s ease-in-out",
                  }}
                />
              </div>

              <button
                type="button"
                className="end-0 p-2 top-0 info-btn border-0 btn btn-primary"
                onClick={() => setPremiumInfoModal(true)}
                style={{ marginLeft: "auto" }}
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 16 16"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path>
                </svg>
              </button>
            </div>
          ) : null}

          {fancyPremium ? (
            detailSport?.matchInfo?.activeStatus?.fancy &&
              !blockStatus.blockAll &&
              !blockStatus.blockFancy ? (
              (() => {
                const activeFancyList = (detailSport?.page?.data?.t3 || []).filter(
                  (item: FancyInterface) => ![1, 18].includes(item?.status1)
                );
                if (activeFancyList.length === 0) {
                  return (
                    <div
                      className="bg-white"
                      style={{ fontSize: "14.56px", fontWeight: 400, padding: "0.5rem 0.75rem", borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px" }}
                    >
                      Markets unavailable. Please check back later.
                    </div>
                  );
                }
                return (
                  <div className="match-odd-table bg-white p-3 py-1 px-0 mobile-match">
                    <div className="d-flex back-lay-head justify-content-end ms-auto pb-1">
                      <span className="text-center w-100">No</span>
                      <span className="text-center w-100">Yes</span>
                    </div>
                    <ul
                      className="rounded position-relative p-0"
                      style={{
                        marginLeft: "2px",
                        marginRight: "2px",
                        marginBottom: "2px",
                      }}
                    >
                      {detailSport?.page?.data?.t3?.length &&
                        stableSort(
                          detailSport?.page?.data?.t3,
                          getComparator("asc", "sortPriority")
                        ).map((item: FancyInterface, i: any) => {
                          let data =
                            JSON.stringify(BET_HISTORY) !== "{}"
                              ? BET_HISTORY?.find(
                                (_: { selection: string }) =>
                                  _.selection === item.nat
                              )
                              : null;

                          return (
                            <React.Fragment key={i}>
                              {![1, 18].includes(item?.status1) && (
                                <li
                                  className="position-relative"
                                  style={{ padding: "0 0 0 8px" }}
                                >
                                  <h2>
                                    {item.nat}
                                    {item?.betProfit &&
                                      cookies.get("skyTokenFront") && (
                                        <span className="d-block py-1 team-red-score">
                                          <span
                                            className={` ${item.betProfit < 0
                                              ? "text-danger"
                                              : "text-green"
                                              } team_total`}
                                          >
                                            {" "}
                                            &gt; (
                                            {parseFloat(
                                              item.betProfit
                                            )?.toFixed(2)}
                                            )
                                          </span>
                                        </span>
                                      )}
                                  </h2>
                                  <div className="lay-back-table">
                                    <div
                                      className={`${clickedBet?.sId === item.sId &&
                                        clickedTableData === "l1"
                                        ? "lay-active"
                                        : ""
                                        } lay spark-lay`}
                                      onClick={(e) => BetClick(item, "l1", "t3", undefined, e.currentTarget)}
                                    >
                                      <strong> {item.l1} </strong>
                                      <span className="d-block">
                                        {" "}
                                        {item.ls1}
                                      </span>
                                    </div>

                                    <div
                                      className={`${clickedBet?.sId === item.sId &&
                                        clickedTableData === "b1"
                                        ? "back-active"
                                        : ""
                                        } back spark-back`}
                                      onClick={(e) => BetClick(item, "b1", "t3", undefined, e.currentTarget)}
                                    >
                                      <strong> {item.b1} </strong>
                                      <span className="d-block">
                                        {" "}
                                        {item.bs1}
                                      </span>
                                    </div>
                                  </div>

                                  {fancyLineClosed(item.status) && (
                                    <div className="overlay-match overlay-fancy">
                                      {fancyClosedMessage(item.status)}
                                    </div>
                                  )}
                                </li>
                              )}
                            </React.Fragment>
                          );
                        })}
                    </ul>
                  </div>
                );
              })()
            ) : null
          ) : isUserLoggedIn &&
            detailSport?.pre?.data?.t4?.length > 0 &&
            detailSport?.matchInfo?.activeStatus?.premium &&
            !blockStatus.blockAll &&
            !blockStatus.blockPremium ? (
            (() => {
              let visibleIndex = -1;
              return (
                <div className="sport-listing" style={{ background: "#fff", padding: "0.5rem" }}>
                  {detailSport?.pre?.data?.t4?.map(
                    (item: PreMainInterface, i: any) => {
                      const itemStatus = String(item?.status || "").toUpperCase();
                      const isDeactivated =
                        itemStatus === "DEACTIVED" ||
                        itemStatus === "DEACTIVATED" ||
                        itemStatus === "DEACTIVE";

                      if (isDeactivated) {
                        return null;
                      }

                      visibleIndex++;
                      const currentVisibleIndex = visibleIndex;
                      const isOpen = isAccordionOpen(item, currentVisibleIndex);

                      const isMarketSuspended =
                        itemStatus === "SUSPEND" ||
                        itemStatus === "SUSPENDED";

                      return (
                        <div className="accordion" key={i}>
                          <div className="accordion-item">
                            <h2
                              className={`${isOpen && item.sub_sb.length > 0
                                ? "active"
                                : ""
                                } accordion-header`}
                              onClick={() => toggleAccordion(item, currentVisibleIndex)}
                            >
                              <button
                                type="button"
                                aria-expanded="true"
                                className="accordion-button"
                              >
                                <svg
                                  stroke="currentColor"
                                  fill="currentColor"
                                  strokeWidth="0"
                                  viewBox="0 0 1024 1024"
                                  height="25"
                                  width="25"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"></path>
                                </svg>
                                {item.marketName}
                              </button>
                            </h2>
                            <div
                              className={`${isOpen && item.sub_sb.length > 0
                                ? "slide-down"
                                : "slide-up"
                                } accordion-collapse `}
                            >
                              <div className="p-0 accordion-body">
                                <div
                                  className="sports-listing-score"
                                  style={{ position: "relative" }}
                                >
                                  <div className="gx-1 row">
                                    {isOpen &&
                                      item.sub_sb.length > 0 &&
                                      item.sub_sb.map(
                                        (subItem: PreSubInterface, j: any) => {
                                          const subStatus = String(
                                            (subItem as any)?.status || ""
                                          ).toUpperCase();
                                          const isSubDeactivated =
                                            subStatus === "DEACTIVED" ||
                                            subStatus === "DEACTIVATED" ||
                                            subStatus === "DEACTIVE";

                                          if (isSubDeactivated) {
                                            return null;
                                          }

                                          const isSubSuspended =
                                            isMarketSuspended ||
                                            subStatus === "SUSPEND" ||
                                            subStatus === "SUSPENDED";

                                          return (
                                            <div
                                              className="position-relative col-6"
                                              key={j}
                                              onClick={(e) => {
                                                if (isSubSuspended) return;
                                                BetClick(
                                                  subItem,
                                                  "odds",
                                                  "t4",
                                                  item,
                                                  e.currentTarget
                                                );
                                              }}
                                            >
                                              <div
                                                className={`${clickedBet?.sId ===
                                                  subItem.sId &&
                                                  clickedTableData === "odds"
                                                  ? "back-active"
                                                  : ""
                                                  } text-center relative team-wise-score${isSubSuspended
                                                    ? " is-suspended"
                                                    : ""
                                                  }`}
                                              >
                                                <span className="d-block">
                                                  {subItem.nat}
                                                </span>
                                                <strong>{subItem.odds}</strong>
                                                {subItem.betProfit && (
                                                  <div className="leading-normal" style={{ marginTop: "0.2rem" }}>
                                                    <div
                                                      className={`${subItem.betProfit < 0
                                                        ? "text-danger"
                                                        : "text-green"
                                                        } d-block`}
                                                    >
                                                      <span
                                                        className={`${subItem.betProfit < 0
                                                          ? "text-danger"
                                                          : "text-green"
                                                          } `}
                                                      >
                                                        {clickedBet?.sId ===
                                                          subItem.sId &&
                                                          clickedTableData ===
                                                          "odds"
                                                          ? parseFloat(
                                                            subItem.betProfit
                                                          )?.toFixed(2)
                                                          : `${parseFloat(
                                                            subItem.betProfit
                                                          )?.toFixed(2)}`}
                                                      </span>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                  </div>

                                  {isMarketSuspended && (
                                    <div
                                      className="sportsbook-suspend-overlay"
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        background: "rgba(111, 136, 152, 0.85)",
                                        borderRadius: "0 0 8px 8px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        zIndex: 20,
                                        cursor: "not-allowed",
                                        userSelect: "none",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: "#ffffff",
                                          fontSize: "11.44px",
                                          fontWeight: 400,

                                        }}
                                      >
                                        Suspend
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              );
            })()
          ) : null}
        </div>
      </div>

      {/* {console.log("sportsWidget", sportsWidget)} */}

      {sportWidgetFlage && sportsWidget?.length ? (
        <div className="sports-widget">
          <div className="position-relative">
            <Slider {...sportsWidgetSetting}>
              {sportsWidget.map((item: any, i: any) => {
                return (
                  <>
                    <style>
                      {`
                      .sports-widget {
                      padding: 10px 0px 0px 0px;
                      }
                    .sports-widget ul {
                        background: #fff;
                        border: 2px solid transparent;
                        border-radius: 6px;
                        color: #000;
                        cursor: pointer;
                        padding: 0px;
                    }
                    .sports-widget ul.widget-active {
                        box-shadow: none;
                    }`}


                    </style>
                    <div
                      style={{ width: "100%", display: "inline-block" }}
                      onClick={() => handleNavigation(item)}
                    >
                      <ul className="widget-active m-0 sports-widget-ul" style={{ border: i === 0 ? "2px solid var(--bgColor)" : "2px solid #fff" }}>
                        <li style={{ fontSize: "9.36px", fontWeight: 400, lineHeight: "9.36px", backgroundColor: i === 0 ? "var(--bgColor)" : "#e2eaef", padding: "2px 5px" }}>
                          Today {moment(item.openDate).format("hh:mm")}
                        </li>
                        <li>
                          <span className="text" style={{ fontSize: "12.48px", fontWeight: 700, lineHeight: "12.48px", padding: "7px 5px 0 5px" }}>
                            {" "}
                            {item.name.split("v")[0]}
                          </span>
                        </li>
                        <li>
                          <span className="text" style={{ fontSize: "12.48px", fontWeight: 700, lineHeight: "12.48px", padding: "0 5px 7px 5px" }}>
                            {" "}
                            {item.name.split("v")[1]}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </>
                );
              })}
            </Slider>
          </div>
          <span className="sports-widget-bottom-text" style={{ color: "var(--bgColor)", marginLeft: "10px", padding: "5px 0" }}>
            {" "}
            {sportsWidget[0].type || "cricket"} in <b>24 hours </b>{" "}
          </span>
          <div
            className="widgetCloseButton"
            onClick={() => setSportWidgetFlage(false)} style={{ fontSize: "27px" }}
          >
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 24 24"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"></path>
            </svg>
          </div>
        </div>
      ) : (
        ""
      )}

      {loginPopup && (
        <Login OpenModal={loginPopup} setOpenModal={setLoginPopup} />
      )}

      {positonModal && (
        <div
          className={`popup-wrp runposition  fade popup-show ${positonModal ? "" : ""
            }`}
        >
          <div className="pop">
            <div className="pop-content">
              <div className="pop-head">
                <h5> Run Position </h5>
                <div
                  className="pop-close"
                  onClick={() => closePositonPopup()}
                ></div>
              </div>
              <div className="pop-body">
                <table className="table table-bordered w-100 fonts-1 mb-0">
                  <thead>
                    <tr>
                      <th style={{ width: "50%" }} className="text-center">
                        Run
                      </th>
                      <th style={{ width: "50%" }} className="text-left">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody className="position">
                    {Object.keys(positonDetails)?.map((item: any, i: any) => {
                      return (
                        <tr key={i}>
                          <td
                            className={`text-center ${positonDetails[item] < 0 ? "pink-bg" : "cyan-bg"
                              }`}
                          >
                            {item}
                          </td>
                          <td
                            className={`text-left ${positonDetails[item] < 0 ? "pink-bg" : "cyan-bg"
                              }`}
                          >
                            {positonDetails[item]}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className="pop-footer">
                <div
                  className={`button-wrap  pb-0 d_flex d_flex_justify_end d_flex_align_center w_100`}
                >
                  <button
                    onClick={() => closePositonPopup()}
                    type="button"
                    className="btn btn-outline-dark btn-sm"
                    data-bs-dismiss="modal"
                  >
                    {" "}
                    Close{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* {console.log("clickedBet", clickedTableData.length)} */}
      {clickedTableData.length > 0 ? (
        <BetBox
          resetClicked={resetBet}
          placeBetClicked={PlaceBat}
          clickedBet={clickedBet}
          clickedTable={clickedTable}
          clickedTableData={clickedTableData}
          setPlaceBetLoader={setPlaceBetLoader}
          placeBetLoader={placeBetLoader}
          stackManage={manageStack}
        />
      ) : (
        <></>
      )}

      {fancyInfoModal && (
        <FancyInfoModal handleClose={() => setFancyInfoModal(false)} />
      )}

      {premiumInfoModal && (
        <PremiumInfoModal handleClose={() => setPremiumInfoModal(false)} />
      )}

      <div className="market-depth-modal mybet">
        {mareketDept && (
          <>
            <div className="market-title">
              <h4>Market Depth</h4>
              <button
                type="button"
                onClick={() => {
                  setMareketDept(false);
                }}
                className="border-0 abc text-white position-absolute end-0 top-0 pt-1 fs-4 bg-transparent border-0 btn btn-primary"
              >
                <svg
                  stroke="currentColor"
                  fill="none"
                  strokeWidth="0"
                  viewBox="0 0 15 15"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </button>
            </div>

            <div
              className="market-depth-body"
              style={{ height: "80vh", overflow: "auto" }}
            >
              <div>
                <MarketDepthPopup depthInfo={detailSport} />
              </div>
            </div>
          </>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default MultiMarket;
